export const FORM_ERROR = 'FORM_ERROR';
export const FORM_CSRF_TOKEN_SUCCESS = 'FORM_CSRF_TOKEN_SUCCESS';
export const FORM_LOAD_DYNAMIC_FIELDS_REQUEST = 'FORM_LOAD_DYNAMIC_FIELDS_REQUEST';
export const FORM_LOAD_DYNAMIC_FIELDS_SUCCESS = 'FORM_LOAD_DYNAMIC_FIELDS_SUCCESS';
export const FORM_SET_HAS_GOOGLE_PLACES_LOADED = 'FORM_SET_HAS_GOOGLE_PLACES_LOADED';

export const SEARCH_SET_RESULT_COMPONENT_PRESENCE = 'SEARCH_SET_RESULT_COMPONENT_PRESENCE';
export const SEARCH_SET_QUERY = 'SEARCH_SET_QUERY';
export const SEARCH_SET_STAGED_QUERY = 'SEARCH_SET_STAGED_QUERY ';
export const SEARCH_CHANGE_CURRENT_TAB = 'SEARCH_CHANGE_CURRENT_TAB';
export const SEARCH_RESET_RESULTS = 'SEARCH_RESET_RESULTS';
export const SEARCH_SET_TAB_RESULTS = 'SEARCH_SET_TAB_RESULTS';
export const SEARCH_SET_TAB_LOADING = 'SEARCH_SET_TAB_LOADING';
export const SEARCH_SET_TAB_SORT_OPTION = 'SEARCH_SET_TAB_SORT_OPTION';
export const SEARCH_SET_TAB_ACTIVE_FILTERS = 'SEARCH_SET_TAB_ACTIVE_FILTERS';
export const SEARCH_SET_SUGGESTIONS_RESULTS = 'SEARCH_SET_SUGGESTIONS_RESULTS';
export const SEARCH_SET_LOADING = 'SEARCH_SET_LOADING';
export const SEARCH_SET_SEARCH_REQUEST = 'SEARCH_SET_SEARCH_REQUEST';
export const SEARCH_SET_SEARCH_AS_YOU_TYPE_ENDPOINT = 'SEARCH_SET_SEARCH_AS_YOU_TYPE_ENDPOINT';
export const SEARCH_SET_ORIGINAL_TERM = 'SEARCH_SET_ORIGINAL_TERM';
export const SEARCH_SET_HAS_INTERACTED = 'SEARCH_SET_HAS_INTERACTED';

export const STORE_LOCATOR_SET_RESULT_COMPONENT_PRESENCE = 'STORE_LOCATOR_SET_RESULT_COMPONENT_PRESENCE';
export const STORE_LOCATOR_SET_KEYWORD = 'STORE_LOCATOR_SET_KEYWORD';
export const STORE_LOCATOR_RESET_RESULTS = 'STORE_LOCATOR_RESET_RESULTS';
export const STORE_LOCATOR_SET_POSITION = 'STORE_LOCATOR_SET_POSITION';
export const STORE_LOCATOR_SET_LOADING = 'STORE_LOCATOR_SET_LOADING';
export const STORE_LOCATOR_SET_RESULTS = 'STORE_LOCATOR_SET_RESULTS';
export const STORE_LOCATOR_SET_FIT_BOUND_STORES = 'STORE_LOCATOR_SET_FIT_BOUND_STORES';
export const STORE_LOCATOR_CHANGE_CURRENT_TAB = 'STORE_LOCATOR_CHANGE_CURRENT_TAB';
export const STORE_LOCATOR_SET_ALL_STORES = 'STORE_LOCATOR_SET_ALL_STORES';
export const STORE_LOCATOR_SET_PLACE_ID = 'STORE_LOCATOR_SET_PLACE_ID';
export const STORE_LOCATOR_SET_VIEWPORT = 'STORE_LOCATOR_SET_VIEWPORT';
export const STORE_LOCATOR_SET_PLACE_SUGGESTIONS = 'STORE_LOCATOR_SET_PLACE_SUGGESTIONS';
export const STORE_LOCATOR_SET_PLACE_SUGGESTIONS_LOADING = 'STORE_LOCATOR_SET_PLACE_SUGGESTIONS_LOADING';
export const STORE_LOCATOR_SET_FETCHED_PLACE = 'STORE_LOCATOR_SET_FETCHED_PLACE';
export const STORE_LOCATOR_RESET_PLACE_ID = 'STORE_LOCATOR_RESET_PLACE_ID';
export const STORE_LOCATOR_SET_BOUTIQUE_ONLY = 'STORE_LOCATOR_SET_BOUTIQUE_ONLY';
export const STORE_LOCATOR_SET_BOUNDS_CHANGED = 'STORE_LOCATOR_SET_BOUNDS_CHANGED';
export const STORE_LOCATOR_SET_SHOULD_LISTEN_TO_BOUNDS_CHANGE = 'STORE_LOCATOR_SET_SHOULD_LISTEN_TO_BOUNDS_CHANGE';

export const STORE_SELECTOR_RESET = 'STORE_SELECTOR_RESET';
export const STORE_SELECTOR_EMPTY = 'STORE_SELECTOR_EMPTY';
export const STORE_SELECTOR_SET_QUERY = 'STORE_SELECTOR_SET_QUERY';
export const STORE_SELECTOR_SET_LOADING = 'STORE_SELECTOR_SET_LOADING';
export const STORE_SELECTOR_SET_STORES = 'STORE_SELECTOR_SET_STORES';
export const STORE_SELECTOR_SET_STORE_PAGE_ID = 'STORE_SELECTOR_SET_STORE_PAGE_ID';

export const WISHLIST_LOAD = 'WISHLIST_LOAD';
export const WISHLIST_LOAD_SUCCESS = 'WISHLIST_LOAD_SUCCESS';
export const WISHLIST_REFRESH_FROM_LOCALSTORAGE = 'WISHLIST_REFRESH_FROM_COOKIE';
export const WISHLIST_SHOW_PROMOTION_BLOCK = 'WISHLIST_SHOW_PROMOTION_BLOCK';
export const WISHLIST_REFRESH_BADGES = 'WISHLIST_REFRESH_BADGES';
export const WISHLIST_REMOVE_REFERENCE_SUCCESS = 'WISHLIST_REMOVE_REFERENCE_SUCCESS';
export const WISHLIST_ADD_REFERENCE_SUCCESS = 'WISHLIST_ADD_REFERENCE_SUCCESS';
export const WISHLIST_ERROR = 'WISHLIST_ERROR';

export const MY_ACCOUNT_ADDRESSES_LOAD = 'MY_ACCOUNT_ADDRESSES_LOAD';
export const MY_ACCOUNT_ADDRESSES_LOAD_SUCCESS = 'MY_ACCOUNT_ADDRESSES_LOAD_SUCCESS';
export const MY_ACCOUNT_ADDRESSES_DELETE_SUCCESS = 'MY_ACCOUNT_ADDRESSES_DELETE_SUCCESS';
export const MY_ACCOUNT_ADDRESSES_SET_DEFAULT = 'MY_ACCOUNT_ADDRESSES_SET_DEFAULT';
export const MY_ACCOUNT_ADDRESSES_SET_DEFAULT_SUCCESS = 'MY_ACCOUNT_ADDRESSES_SET_DEFAULT_SUCCESS';
export const MY_ACCOUNT_ADDRESSES_SAVE = 'MY_ACCOUNT_ADDRESSES_SAVE';
export const MY_ACCOUNT_ADDRESSES_SAVE_SUCCESS = 'MY_ACCOUNT_ADDRESSES_SAVE_SUCCESS';
export const MY_ACCOUNT_ADDRESSES_OPEN_DELETE_CONFIRMATION_MODAL =
  'MY_ACCOUNT_ADDRESSES_OPEN_DELETE_CONFIRMATION_MODAL';
export const MY_ACCOUNT_ORDERS_SET_LOADING = 'MY_ACCOUNT_ORDERS_SET_LOADING';
export const MY_ACCOUNT_ORDERS_SET_ORDERS = 'MY_ACCOUNT_ORDERS_SET_ORDERS';
export const MY_ACCOUNT_ORDERS_SET_SELECTED = 'MY_ACCOUNT_ORDERS_SET_SELECTED';
export const MY_ACCOUNT_ORDERS_UPDATE_ORDER = 'MY_ACCOUNT_ORDERS_UPDATE_ORDER';
export const MY_ACCOUNT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS = 'MY_ACCOUNT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS';
export const MY_ACCOUNT_SET_ORDERS_LINE_DATA = 'MY_ACCOUNT_SET_ORDERS_LINE_DATA';
export const MY_ACCOUNT_UPDATE_ORDER_LINE_DATA = 'MY_ACCOUNT_UPDATE_ORDER_LINE_DATA';
export const MY_ACCOUNT_RETURNEXCHANGE_ADDRESS_SET = 'MY_ACCOUNT_RETURNEXCHANGE_ADDRESS_SET';
export const MY_ACCOUNT_ORDERS_SET_GROUPS = 'MY_ACCOUNT_ORDERS_SET_GROUPS';
export const MY_ACCOUNT_ORDERS_SET_COUNTRIES = 'MY_ACCOUNT_ORDERS_SET_COUNTRIES';
export const MY_ACCOUNT_SET_REFUND_EXCHANGE_REASON = 'MY_ACCOUNT_SET_REFUND_EXCHANGE_REASON';
export const MY_ACCOUNT_RETURN_EXCHANGE_IS_EDITING_ADDRESS = 'MY_ACCOUNT_RETURN_EXCHANGE_IS_EDITING_ADDRESS';

export const CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IN_FORM = 'CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IN_FORM';
export const CUSTOMER_ADDRESS_FROM_SUGGESTED_ADDRESSES_LOADED_SUCCESS =
  'CUSTOMER_ADDRESS_FROM_SUGGESTED_ADDRESSES_LOADED_SUCCESS';
export const CUSTOMER_ADDRESS_SUGGESTED_ADDRESSES_DELETE = 'CUSTOMER_ADDRESS_SUGGESTED_ADDRESSES_DELETE';
export const CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IS_SAVING = 'CUSTOMER_ADDRESS_FORM_SET_ADDRESS_IS_SAVING';
export const CUSTOMER_ADDRESS_FORM_SET_RANDOM_ID = 'CUSTOMER_ADDRESS_FORM_SET_RANDOM_ID';
export const CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_ZIP_SEARCH_FORM =
  'CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_ZIP_SEARCH_FORM';
export const CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_SUGGESTIONS =
  'CUSTOMER_ADDRESS_FORM_SET_SHOULD_DISPLAY_SUGGESTIONS';
export const CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS = 'CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS';
export const CUSTOMER_ADDRESS_FORM_SET_LOADING_SUGGESTIONS = 'CUSTOMER_ADDRESS_FORM_SET_LOADING_SUGGESTIONS';
export const CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS_ERROR = 'CUSTOMER_ADDRESS_FORM_SET_SUGGESTIONS_ERROR';
export const CUSTOMER_ADDRESS_FORM_SET_INITIAL_SUGGESTION_ADDRESS =
  'CUSTOMER_ADDRESS_FORM_SET_INITIAL_SUGGESTION_ADDRESS';

export const CHECKOUT_SET_LOADING = 'CHECKOUT_SET_LOADING';
export const CHECKOUT_LOAD_CART_SUCCESS = 'CHECKOUT_LOAD_CART_SUCCESS';
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR';
export const CHECKOUT_SET_CURRENT_CART_ITEM_ID = 'CHECKOUT_SET_CURRENT_CART_ITEM_ID';
export const CHECKOUT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS = 'CHECKOUT_SUGGESTED_ADDRESSES_ACCEPT_SUCCESS';
export const CHECKOUT_LOAD_ADDRESSES_SUCCESS = 'CHECKOUT_LOAD_ADDRESSES_SUCCESS';
export const CHECKOUT_SUMMARY_LOADING = 'CHECKOUT_SUMMARY_LOADING';
export const CHECKOUT_DELIVERY_LOADING = 'CHECKOUT_DELIVERY_LOADING';
export const CHECKOUT_LOAD_BOUTIQUES_SUCCESS = 'CHECKOUT_LOAD_BOUTIQUES_SUCCESS';
export const CHECKOUT_SET_SELECTED_BOUTIQUE_ID = 'CHECKOUT_SET_SELECTED_BOUTIQUE_ID';
export const CHECKOUT_SET_SELECTED_ADDRESS_ID = 'CHECKOUT_SET_SELECTED_ADDRESS_ID';
export const CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS_ID = 'CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS_ID';
export const CHECKOUT_BILLING_LOADING = 'CHECKOUT_BILLING_LOADING';
export const CHECKOUT_PAYMENT_LOADING = 'CHECKOUT_PAYMENT_LOADING';
export const CHECKOUT_SET_ADDRESS_TYPE = 'CHECKOUT_SET_ADDRESS_TYPE';
export const CHECKOUT_SET_EDITING_ADDRESS_ID = 'CHECKOUT_SET_EDITING_ADDRESS_ID';
export const CHECKOUT_SET_DEFAULT_DELIVERY_TYPE = 'CHECKOUT_SET_DEFAULT_DELIVERY_TYPE';
export const CHECKOUT_SET_3DSECURE = 'CHECKOUT_SET_3DSECURE';
export const CHECKOUT_SET_3DSECURE2_IDENTIFY_SHOPPER = 'CHECKOUT_SET_3DSECURE2_IDENTIFY_SHOPPER';
export const CHECKOUT_SET_3DSECURE2_CHALLENGE_SHOPPER = 'CHECKOUT_SET_3DSECURE2_CHALLENGE_SHOPPER';
export const CHECKOUT_SET_ADYEN_IDENTIFY_RESPONSE = 'CHECKOUT_SET_ADYEN_IDENTIFY_RESPONSE';
export const CHECKOUT_SET_ADYEN_CHALLENGE_RESPONSE = 'CHECKOUT_SET_ADYEN_CHALLENGE_RESPONSE';
export const CHECKOUT_SET_US_PAYMENT_IFRAME_ERROR = 'CHECKOUT_SET_US_PAYMENT_IFRAME_ERROR';
export const CHECKOUT_FILL_PAYMENT_DATA = 'CHECKOUT_FILL_PAYMENT_DATA';
export const CHECKOUT_SET_IFRAME_RETURN_SUCCESS = 'CHECKOUT_SET_IFRAME_RETURN_SUCCESS';
export const CHECKOUT_SET_PAYMENT_FORM = 'CHECKOUT_SET_PAYMENT_FORM';
export const CHECKOUT_SET_FAPIAO_TYPE = 'CHECKOUT_SET_FAPIAO_TYPE';
export const CHECKOUT_SET_STEP = 'CHECKOUT_SET_STEP';
export const CHECKOUT_SET_GROUPS_AND_COUNTRIES = 'CHECKOUT_SET_GROUPS_AND_COUNTRIES';
export const CHECKOUT_ADD_MOUNTED_STEP = 'CHECKOUT_ADD_MOUNTED_STEP';
export const CHECKOUT_SET_GUEST_EMAIL_ADDRESS = 'CHECKOUT_SET_GUEST_EMAIL_ADDRESS';

export const CURRENT_USER_SET_IS_LOGGED_SUCCESS = 'CURRENT_USER_SET_IS_LOGGED_SUCCESS';
export const CURRENT_USER_INFO_SUCCESS = 'CURRENT_USER_INFO_SUCCESS';
export const CURRENT_USER_INFO_SET_LOADING = 'CURRENT_USER_INFO_SET_LOADING';
export const CURRENT_USER_INFO_SET_FORM_DATA = 'CURRENT_USER_INFO_SET_FORM_DATA';
export const CURRENT_USER_SET_ON_SUBMIT_TOKEN_CALLBACK = 'CURRENT_USER_SET_ON_SUBMIT_TOKEN_CALLBACK';

export const PHONE_TOKEN_MODAL_SET_PHONE_NUMBER_TO_VALIDATE = 'PHONE_TOKEN_MODAL_SET_PHONE_NUMBER_TO_VALIDATE';
export const PHONE_TOKEN_MODAL_SET_TOKEN_TYPE = 'PHONE_TOKEN_MODAL_SET_TOKEN_TYPE';
export const PHONE_TOKEN_MODAL_SET_IS_SENDING = 'PHONE_TOKEN_MODAL_SET_IS_SENDING';
export const PHONE_TOKEN_MODAL_SET_ERROR = 'PHONE_TOKEN_MODAL_SET_ERROR';

export const CART_PREVIEW_SET_ITEMS = 'CART_PREVIEW_SET_ITEMS';
export const CART_PREVIEW_LOADING = 'CART_PREVIEW_LOADING';
export const CART_PREVIEW_ITEM_COUNT = 'CART_PREVIEW_ITEM_COUNT';

export const LIGHT_CHECKOUT_INIT = 'LIGHT_CHECKOUT_INIT';
export const LIGHT_CHECKOUT_SET_GIFT_WRAP = 'LIGHT_CHECKOUT_SET_GIFT_WRAP';
export const LIGHT_CHECKOUT_SET_GIFT_HAS_MESSAGE = 'LIGHT_CHECKOUT_SET_GIFT_HAS_MESSAGE';
export const LIGHT_CHECKOUT_SET_GIFT_MESSAGE = 'LIGHT_CHECKOUT_SET_GIFT_MESSAGE';
export const LIGHT_CHECKOUT_SET_GIFT_MESSAGE_FONT = 'LIGHT_CHECKOUT_SET_GIFT_MESSAGE_FONT';
export const LIGHT_CHECKOUT_SET_DELIVERY_MODE = 'LIGHT_CHECKOUT_SET_DELIVERY_MODE';
export const LIGHT_CHECKOUT_SET_SELECTED_BOUTIQUE = 'LIGHT_CHECKOUT_SET_SELECTED_BOUTIQUE';
export const LIGHT_CHECKOUT_SET_DELIVERY_ADDRESS = 'LIGHT_CHECKOUT_SET_DELIVERY_ADDRESS';
export const LIGHT_CHECKOUT_EDIT_DELIVERY_ADDRESS = 'LIGHT_CHECKOUT_EDIT_DELIVERY_ADDRESS';
export const LIGHT_CHECKOUT_SET_BILLING_ADDRESS = 'LIGHT_CHECKOUT_SET_BILLING_ADDRESS';
export const LIGHT_CHECKOUT_EDIT_BILLING_ADDRESS = 'LIGHT_CHECKOUT_EDIT_BILLING_ADDRESS';
export const LIGHT_CHECKOUT_SET_BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS =
  'LIGHT_CHECKOUT_SET_BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS';
export const LIGHT_CHECKOUT_EDIT_CONTACT_INFORMATIONS = 'LIGHT_CHECKOUT_EDIT_CONTACT_INFORMATIONS';
export const LIGHT_CHECKOUT_SET_CONTACT_INFORMATIONS = 'LIGHT_CHECKOUT_SET_CONTACT_INFORMATIONS';
export const LIGHT_CHECKOUT_SET_ADDITIONAL_INFORMATIONS = 'LIGHT_CHECKOUT_SET_ADDITIONAL_INFORMATIONS';
export const LIGHT_CHECKOUT_SET_NEWSLETTER = 'LIGHT_CHECKOUT_SET_NEWSLETTER';
export const LIGHT_CHECKOUT_SUBMIT_REQUEST = 'LIGHT_CHECKOUT_SUBMIT_REQUEST';
export const LIGHT_CHECKOUT_SUBMIT_SUCCESS = 'LIGHT_CHECKOUT_SUBMIT_SUCCESS';
export const LIGHT_CHECKOUT_SUBMIT_FAILURE = 'LIGHT_CHECKOUT_SUBMIT_FAILURE';

export const STRAP_SEARCH_REQUEST = 'STRAP_SEARCH_REQUEST';
export const STRAP_SEARCH_SUCCESS = 'STRAP_SEARCH_SUCCESS';
export const STRAP_SEARCH_FAILURE = 'STRAP_SEARCH_FAILURE';
export const STRAP_SEARCH_SET_WATCH_REF = 'STRAP_SEARCH_SET_WATCH_REF';
export const STRAP_SEARCH_SET_BLOCK_FILTERS_ID = 'STRAP_SEARCH_SET_BLOCK_FILTERS_ID';

export const STRAP_SEARCH_SET_SUGGESTIONS = 'STRAP_SEARCH_SET_SUGGESTIONS';
export const STRAP_SEARCH_SUGGESTION_REQUEST = 'STRAP_SEARCH_SUGGESTION_REQUEST';
export const STRAP_SEARCH_SUGGESTIONS_FAILURE = 'STRAP_SEARCH_SUGGESTIONS_FAILURE';

export const ENGRAVING_TOOL_MODAL_SET_CURRENT_VIEW = 'ENGRAVING_TOOL_MODAL_SET_CURRENT_VIEW';
export const ENGRAVING_TOOL_MODAL_SET_DATA = 'ENGRAVING_TOOL_MODAL_SET_DATA';
export const ENGRAVING_TOOL_MODAL_SET_REFERENCE = 'ENGRAVING_TOOL_MODAL_SET_REFERENCE';
